export default __webpack_public_path__ + "static/Download on App Store-8d613a500acdd23cbebe9ee16117410f.png";